const VALID_TYPES_FILE = ["application/pdf", "image/jpg", "image/jpeg", "image/bmp", "image/png"]
const FILE_MAX_SIZE = 10240;
const MAX_FILES = 6

module.exports = {
    VALID_TYPES_FILE,
    FILE_MAX_SIZE,
    MAX_FILES
}